import React from 'react'
import { subscribe } from 'react-contextual'
import { SearchFilter } from '../../../views/components'
// Imported off its own path, not the views/components barrel: the barrel and this module are in a
// require cycle, so a named import off it is still undefined while this file is evaluating.
import Header from '../../../views/components/molecules/Header/Header'
import PeopleIcon from '../../../views/components/atoms/Svgs/People'
import ContactsProvider from '../state/ContactsProvider'
import ContactFilterPills from './ContactFilterPills/ContactFilterPills'
import styles from './SearchFilter.module.scss'

const ContactsSearchFilter = (props: any) => (
  <SearchFilter
    {...props}
    subFilters={
      <>
        <Header className={styles.heading} icon={<PeopleIcon />} text="Contacts" />
        <ContactFilterPills />
      </>
    }
  />
)

export default subscribe([ContactsProvider], ({ location, redirect, filters }: any) => ({
  pathname: location.pathname,
  redirect,
  filters,
}))(ContactsSearchFilter)
